function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZajmoveUzemi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147 147.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13.17,
    y1: 24.07,
    x2: 13.17,
    y2: 124.16,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.47,
    y1: 12.33,
    x2: 23.83,
    y2: 12.33,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.5,
    y1: 123.64,
    x2: 134.5,
    y2: 24.2,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.35,
    y1: 136,
    x2: 123.31,
    y2: 136,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.83,
    cy: 12.83,
    r: 10.33,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.83,
    cy: 134.67,
    r: 10.33,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.17,
    cy: 134.67,
    r: 10.33,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.17,
    cy: 12.83,
    r: 10.33,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZajmoveUzemi);
export default __webpack_public_path__ + "static/media/zajmove-uzemi.7ebe48c6de176d7ff847fbdb91a4f777.svg";
export { ForwardRef as ReactComponent };